import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";

export default function ClientForm() {
  console.log("🔥 ClientForm mounted");

  const { token } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;

    const loadForm = async () => {
      try {
        const data = await apiFetch(`/api/forms/${token}`);
        setForm(data);
      } catch (err) {
        console.error("❌ Failed to load form:", err);
        setError("This form is no longer available.");
      } finally {
        setLoading(false);
      }
    };

    loadForm();
  }, [token]);

  if (loading) return <p>Loading…</p>;
  if (error) return <p>{error}</p>;
  if (!form) return null;

  return (
    <div>
      <h1>{form.clientName}</h1>
      {/* form fields */}
    </div>
  );
}
